/* Catalogue Kingdom Titans × SortSwift — v2.1
   Fichier de thème : assets/kt-catalogue.js, chargé par la section « Liquid personnalisé » de la page catalogue.
   Fichier public : aucune clé ici. La signature du client connecté vient de la section, calculée par Shopify. */
(() => {
  const root = document.getElementById('kt-ss');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  const ds = root.dataset;
  const cfg = {
    api: (ds.api || '').replace(/\/+$/, ''),
    mode: ds.apiMode === 'direct' ? 'direct' : 'relay',
    slug: ds.slug || 'kingdomtitans',
    category: ds.category || '1',
    pageSize: Math.min(60, Math.max(12, parseInt(ds.pageSize, 10) || 48)),
    inStock: ds.inStock !== 'false',
    openDrawer: ds.openDrawer !== 'false',
    lang: /^fr/i.test(ds.locale || document.documentElement.lang || '') ? 'fr' : 'en',
    currency: ds.currency || 'CAD',
    addUrl: (ds.cartAddUrl || '/cart/add') + '.js',
    loginUrl: ds.loginUrl || '/account/login'
  };

  // Client Shopify connecté, signé par Shopify côté serveur (Liquid). Lu une fois, puis retiré de la page.
  const who = /^\d{1,20}$/.test(ds.customerId || '') && /^\d{9,11}$/.test(ds.customerTs || '') && /^[0-9a-f]{64}$/.test(ds.customerSig || '')
    ? { customerId: ds.customerId, email: ds.customerEmail || '', ts: ds.customerTs, sig: ds.customerSig }
    : null;
  const shopCustomer = ds.customer === '1';
  const custEmail = ds.customerEmail || '';
  ['customerId', 'customerEmail', 'customerTs', 'customerSig'].forEach(k => { delete ds[k]; });

  const STR = {
    en: { search: 'Search for a card…', filters: 'Filters', set: 'Set', allSets: 'All sets', rarity: 'Rarity', color: 'Color', type: 'Card type', condition: 'Condition', language: 'Language', finish: 'Finish', format: 'Format', any: 'Any', inStockOnly: 'In stock only', reset: 'Reset', sortBy: 'Sort', sortRel: 'Relevance', sortName: 'Name A–Z', sortPriceAsc: 'Price: low to high', sortPriceDesc: 'Price: high to low', sortNew: 'Newest', count: '{n} cards', countStock: '{n} cards in stock', loadMore: 'Load more', loading: 'Loading…', empty: 'No cards match these filters.', error: 'The catalog couldn’t load.', retry: 'Retry', inStock: 'In stock', outOfStock: 'Out of stock', addToCart: 'Add to cart', addNamed: 'Add {name} to cart', added: 'Added to cart', addedNamed: '{name} added to cart', variants: '{n} options', left1: '1 left', leftN: '{n} in stock', qty: 'Quantity', close: 'Close', available: 'Available copies', noneInStock: 'No copies in stock right now.', notOnline: 'This card can’t be added online right now. Contact us and we’ll set it aside.', soldOut: 'This card just sold out.', addError: 'Couldn’t add this card to your cart.', est: 'est.', estHint: 'Estimated price when it’s back in stock', notify: 'Notify me', wished: '✓ On your wishlist', wishedToast: 'Added to your wishlist. We’ll email you when it’s back in stock.', wishError: 'Couldn’t add this card to your wishlist.', oosTitle: 'Out of stock', nTitle: 'Back-in-stock alert', nLogin: 'Log in to add it to my wishlist', nLoginHint: 'Your wishlist stays in your account, and we’ll email you as soon as the card is back.', or: 'or', nEmailLabel: 'Just email me', nEmailPh: 'you@example.com', nSubmit: 'Notify me', subActive: 'You’re all set. We’ll email you when it’s back in stock.', subPending: 'Almost done: confirm your email with the link we just sent you.', badEmail: 'Enter a valid email address.', subError: 'Something went wrong. Please try again.', linkFail: 'We couldn’t link your account, but you can still get an email alert.', W: 'White', U: 'Blue', B: 'Black', R: 'Red', G: 'Green', C: 'Colorless', M: 'Multicolor', NM: 'Near Mint', LP: 'Lightly Played', MP: 'Moderately Played', HP: 'Heavily Played', DM: 'Damaged', DMG: 'Damaged' },
    fr: { search: 'Rechercher une carte…', filters: 'Filtres', set: 'Extension', allSets: 'Toutes les extensions', rarity: 'Rareté', color: 'Couleur', type: 'Type de carte', condition: 'État', language: 'Langue', finish: 'Fini', format: 'Format', any: 'Tous', inStockOnly: 'En stock seulement', reset: 'Réinitialiser', sortBy: 'Trier', sortRel: 'Pertinence', sortName: 'Nom A–Z', sortPriceAsc: 'Prix croissant', sortPriceDesc: 'Prix décroissant', sortNew: 'Plus récentes', count: '{n} cartes', countStock: '{n} cartes en stock', loadMore: 'Afficher plus', loading: 'Chargement…', empty: 'Aucune carte ne correspond à ces filtres.', error: 'Le catalogue n’a pas pu être chargé.', retry: 'Réessayer', inStock: 'En stock', outOfStock: 'Épuisée', addToCart: 'Ajouter au panier', addNamed: 'Ajouter {name} au panier', added: 'Ajoutée au panier', addedNamed: '{name} ajoutée au panier', variants: '{n} options', left1: '1 restante', leftN: '{n} en stock', qty: 'Quantité', close: 'Fermer', available: 'Exemplaires disponibles', noneInStock: 'Aucun exemplaire en stock pour le moment.', notOnline: 'Cette carte ne peut pas être ajoutée en ligne pour le moment. Écris-nous et on la met de côté.', soldOut: 'Cette carte vient d’être vendue.', addError: 'Impossible d’ajouter cette carte au panier.', est: 'est.', estHint: 'Prix estimé à son retour en stock', notify: 'M’avertir', wished: '✓ Sur ta liste', wishedToast: 'Ajoutée à ta liste de souhaits. On t’écrit dès qu’elle revient en stock.', wishError: 'Impossible d’ajouter cette carte à ta liste.', oosTitle: 'Épuisées', nTitle: 'Alerte de retour en stock', nLogin: 'Me connecter pour l’ajouter à ma liste', nLoginHint: 'Ta liste de souhaits reste dans ton compte, et on t’écrit dès que la carte revient.', or: 'ou', nEmailLabel: 'Seulement m’avertir par courriel', nEmailPh: 'ton@courriel.com', nSubmit: 'M’avertir', subActive: 'C’est noté ! On t’écrit dès qu’elle revient en stock.', subPending: 'Presque fini : confirme ton adresse avec le lien qu’on vient de t’envoyer.', badEmail: 'Entre une adresse courriel valide.', subError: 'Une erreur est survenue. Réessaie.', linkFail: 'On n’a pas pu lier ton compte, mais tu peux quand même recevoir une alerte par courriel.', W: 'Blanc', U: 'Bleu', B: 'Noir', R: 'Rouge', G: 'Vert', C: 'Incolore', M: 'Multicolore', NM: 'Quasi neuf (NM)', LP: 'Légèrement joué (LP)', MP: 'Modérément joué (MP)', HP: 'Très joué (HP)', DM: 'Endommagé (DM)', DMG: 'Endommagé (DM)' }
  };
  const T = STR[cfg.lang];
  const LANGS = { en: { EN: 'English', JP: 'Japanese', JA: 'Japanese', FR: 'French', ES: 'Spanish', DE: 'German', IT: 'Italian', PT: 'Portuguese', KO: 'Korean', KR: 'Korean', RU: 'Russian', ZH: 'Chinese', CS: 'Chinese (S)', CT: 'Chinese (T)' }, fr: { EN: 'Anglais', JP: 'Japonais', JA: 'Japonais', FR: 'Français', ES: 'Espagnol', DE: 'Allemand', IT: 'Italien', PT: 'Portugais', KO: 'Coréen', KR: 'Coréen', RU: 'Russe', ZH: 'Chinois', CS: 'Chinois (S)', CT: 'Chinois (T)' } }[cfg.lang];
  const RANK = { NM: 0, LP: 1, MP: 2, HP: 3, DM: 4, DMG: 4, D: 4 };
  const SORTS = [['', 'sortRel'], ['name:asc', 'sortName'], ['price:asc', 'sortPriceAsc'], ['price:desc', 'sortPriceDesc'], ['newest:desc', 'sortNew']];
  // clé d'état : [paramètre d'URL de la page, paramètre de l'API SortSwift]
  const FIELDS = { search: ['q', 'search'], groupId: ['set', 'groupId'], rarity: ['rarity', 'rarity'], color: ['color', 'color'], type: ['type', 'type'], condition: ['cond', 'condition'], language: ['lang', 'language'], printing: ['finish', 'printing'], legal: ['format', 'legalStatuses'], sort: ['sort', null] };
  const FACETS = { rarity: 'rarities', type: 'types', condition: 'conditions', language: 'languages', printing: 'printings', legal: 'legalStatuses' };
  const ICON = '<svg viewBox="0 0 24 24" width="21" height="21" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2.5 3.5h2.2l2.5 10.6a2 2 0 0 0 2 1.5h7.6a2 2 0 0 0 1.9-1.4l1.8-6.2H6"/><circle cx="10" cy="20" r="1.3"/><circle cx="17.2" cy="20" r="1.3"/><path d="M13.3 8.6v4.2M11.2 10.7h4.2"/></svg>';

  const S = { search: '', groupId: '', rarity: '', color: '', type: '', condition: '', language: '', printing: '', legal: '', sort: '', inStock: cfg.inStock, page: 1 };
  const ITEMS = new Map();     // cartes affichées dans la grille
  const PRODUCTS = new Map();  // nom, extension… par carte, pour la liste de souhaits
  const DETAIL = new Map();
  const WISHED = new Set();    // cartes déjà dans la liste de souhaits du client
  const loc = cfg.lang === 'fr' ? 'fr-CA' : 'en-CA';
  const moneyFmt = new Intl.NumberFormat(loc, { style: 'currency', currency: cfg.currency, currencyDisplay: 'narrowSymbol' });
  const money = cents => moneyFmt.format((Number(cents) || 0) / 100) + ' ' + cfg.currency;
  const num = n => new Intl.NumberFormat(loc).format(n || 0);
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const fill = (str, map) => str.replace(/\{(\w+)\}/g, (m, k) => (k in map ? map[k] : m));
  const rank = v => (v.condAbbr in RANK ? RANK[v.condAbbr] : 9);
  const label = (key, v) => (key === 'condition' ? T[v] || v : key === 'language' ? LANGS[v] || v : key === 'legal' ? v.charAt(0).toUpperCase() + v.slice(1) : v);
  const projected = o => (o && typeof o.projectedPrice === 'number' && o.projectedPrice >= 0 ? o.projectedPrice : null);
  const est = cents => `~${esc(money(cents))} <small>${esc(T.est)}</small>`;
  const printLabel = o => o.printing || (o.finish === 'foil' ? 'Foil' : 'Normal');
  const ss = {
    get: k => { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set: (k, v) => { try { if (v == null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) { /* stockage bloqué */ } }
  };

  // ---------- API SortSwift : catalogue (lecture) ----------
  const apiUrl = (ep, params) => {
    const q = new URLSearchParams();
    Object.entries(params || {}).forEach(([k, v]) => { if (v !== '' && v != null && v !== false) q.set(k, String(v)); });
    if (cfg.mode === 'relay') { q.set('ep', ep); return cfg.api + '?' + q; }
    const s = q.toString();
    return cfg.api + '/' + ep + (s ? '?' + s : '');
  };
  const getJSON = async (ep, params, signal) => {
    const r = await fetch(apiUrl(ep, params), { headers: { Accept: 'application/json' }, signal });
    if (!r.ok) throw new Error('HTTP ' + r.status);
    const j = await r.json();
    return j && typeof j === 'object' && 'data' in j ? j.data : j;
  };
  const getDetail = id => {
    const hit = DETAIL.get(id);
    if (hit && Date.now() - hit.t < 60000) return hit.p;
    const p = getJSON('catalog/' + encodeURIComponent(id)).catch(e => { DETAIL.delete(id); throw e; });
    DETAIL.set(id, { t: Date.now(), p });
    return p;
  };

  // ---------- API SortSwift : compte client (liste de souhaits, alertes) ----------
  // Réponse uniforme : { ok, status, data, code }.
  const unwrap = j => (j && typeof j === 'object' && 'data' in j ? j.data : j);
  const listOf = d => (Array.isArray(d) ? d : d && typeof d === 'object' ? (Array.isArray(d.items) ? d.items : Array.isArray(d.wishlists) ? d.wishlists : []) : []);
  // Relais : POST « simple » (corps JSON en text/plain, sans en-tête perso), donc sans requête préalable CORS.
  const relayAct = async (action, body) => {
    const r = await fetch(cfg.api + '?ep=' + encodeURIComponent(action), { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'text/plain;charset=UTF-8' }, body: JSON.stringify(body), credentials: 'omit' });
    const j = await r.json().catch(() => null);
    return j && typeof j === 'object' && 'ok' in j ? j : { ok: false, status: r.status };
  };
  // Direct : mêmes appels que le widget SortSwift, possibles seulement si SortSwift autorise le domaine.
  const directAct = async (action, body) => {
    const call = async (url, opt = {}) => {
      const h = { Accept: 'application/json' };
      if (opt.body) h['Content-Type'] = 'application/json';
      if (opt.key) h['x-customer-token'] = opt.key;
      const r = await fetch(url, { method: opt.method || 'GET', headers: h, body: opt.body ? JSON.stringify(opt.body) : undefined, credentials: 'omit' });
      const j = await r.json().catch(() => ({}));
      return { ok: r.ok, status: r.status, data: unwrap(j), code: j && j.code };
    };
    const lists = new URL(cfg.api).origin + '/api/player/wishlists';
    if (action === 'session') return call(cfg.api + '/shopify-customer-session', { method: 'POST', body });
    if (action === 'restock') return call(cfg.api + '/restock/subscribe', { method: 'POST', body });
    if (action === 'wishlist') return call(lists, { key: body.token });
    if (action === 'wishlist/add') {
      let r = await call(lists, { key: body.token });
      if (!r.ok) return r;
      let w = listOf(r.data)[0];
      if (!w) {
        r = await call(lists, { method: 'POST', key: body.token, body: { name: 'My Wishlist' } });
        if (!r.ok) return r;
        w = r.data && (r.data.wishlist || r.data);
      }
      const id = w && (w._id || w.id);
      if (!id) return { ok: false, status: 502 };
      return call(lists + '/' + encodeURIComponent(id) + '/items', { method: 'POST', key: body.token, body: body.item });
    }
    return { ok: false, status: 400 };
  };
  const act = (action, body) => (cfg.mode === 'relay' ? relayAct : directAct)(action, body).catch(() => ({ ok: false, status: 0 }));

  // Session SortSwift du client : échange de l'identité signée contre une session, gardée pour l'onglet.
  const KEY = who ? 'kt-ss-sess:' + who.customerId : '';
  const PENDING = 'kt-ss-pending';
  const RELOADED = 'kt-ss-reloaded';
  let sess = KEY ? ss.get(KEY) : null;
  let sessP = null;
  let link = who ? 'pending' : shopCustomer ? 'nolink' : 'none'; // none = visiteur, nolink = client Shopify non lié
  const signIn = force => {
    if (!who) return Promise.resolve(null);
    if (sess && !force) return Promise.resolve(sess);
    if (!sessP) {
      sessP = act('session', who).then(r => {
        sessP = null;
        const t = r.ok && r.data && r.data.token;
        sess = typeof t === 'string' && t ? t : null;
        ss.set(KEY, sess);
        if (!sess) console.warn('[kt-ss] Liaison du compte SortSwift impossible :', r.code || r.status);
        return sess;
      });
    }
    return sessP;
  };
  // Exécute un appel avec la session; si elle a expiré, refait l'échange une fois.
  const withSession = async fn => {
    for (let i = 0; i < 2; i += 1) {
      const key = await signIn(i > 0);
      if (!key) break;
      const r = await fn(key);
      if (r.status !== 401) return r;
      sess = null;
      ss.set(KEY, null);
    }
    return { ok: false, status: 401, noSession: true };
  };
  const remember = (pid, fin) => { WISHED.add(String(pid)); WISHED.add(pid + '|' + (fin || '')); };
  // Carte entière (grille) ou impression précise (fenêtre de détail; « any » couvre normal et foil).
  const isOn = (pid, fin, row) => (row ? WISHED.has(pid + '|') || WISHED.has(pid + '|' + fin) : WISHED.has(String(pid)));
  const loadWished = async () => {
    const r = await withSession(key => act('wishlist', { token: key }));
    if (!r.ok) return;
    ss.set(RELOADED, null);
    listOf(r.data).forEach(w => listOf(w && w.items).forEach(it => {
      const pid = it && (it.productId || it.product_id);
      if (pid) remember(pid, it.finish === 'foil' ? 'foil' : '');
    }));
    refreshNotify();
  };
  const wishAdd = async subj => {
    const item = { matchScope: 'printing', cardName: subj.cardName || null, categoryId: subj.categoryId != null ? Number(subj.categoryId) : null, oracle_id: subj.oracleId || null, productId: Number(subj.productId), skuId: null, finish: subj.finish || null, language: null, minCondition: null, notifyOnRestock: true };
    const r = await withSession(key => act('wishlist/add', { token: key, item }));
    if (r.ok) remember(subj.productId, subj.finish);
    return r;
  };
  const savePending = subj => ss.set(PENDING, JSON.stringify({ subj, t: Date.now() }));
  const takePending = () => {
    const raw = ss.get(PENDING);
    ss.set(PENDING, null);
    try { const p = JSON.parse(raw); return p && p.subj && Date.now() - p.t < 30 * 60000 ? p.subj : null; } catch (e) { return null; }
  };
  const loginHref = () => {
    try {
      const u = new URL(cfg.loginUrl, location.href);
      if (u.origin !== location.origin) return null;
      const back = location.pathname + location.search;
      u.searchParams.set('return_url', back); // comptes classiques
      u.searchParams.set('return_to', back);  // nouveaux comptes clients
      return u.href;
    } catch (e) { return null; }
  };

  // ---------- Panier Shopify (thème Dawn) ----------
  const addToCart = async (variantId, qty) => {
    const drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const render = cfg.openDrawer && drawer && typeof drawer.renderContents === 'function' && typeof drawer.getSectionsToRender === 'function';
    const body = { id: Number(variantId), quantity: qty || 1 };
    if (render) { body.sections = drawer.getSectionsToRender().map(s => s.id).join(','); body.sections_url = location.pathname; }
    else body.sections = 'cart-icon-bubble';
    const r = await fetch(cfg.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) });
    const data = await r.json().catch(() => ({}));
    if (!r.ok || data.status) throw new Error(data.description || data.message || T.addError);
    if (render) {
      drawer.renderContents(data);
      drawer.classList.remove('is-empty');
    } else {
      const bubble = document.getElementById('cart-icon-bubble');
      const html = data.sections && data.sections['cart-icon-bubble'];
      const src = html && new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
      if (bubble && src) bubble.innerHTML = src.innerHTML;
    }
    try { if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'kt-ss-catalog', productVariantId: variantId, cartData: data }); } catch (e) { /* rien */ }
    document.dispatchEvent(new CustomEvent('kt-ss:added', { detail: data }));
    return render;
  };
  const sellable = d => (d.variants || []).filter(v => v.shopify_variant_id && (v.availableQty || 0) > 0 && v.inStock !== false);
  const pickVariant = (item, d) => {
    const list = sellable(d);
    if (!list.length) return null;
    if (item && item.bestConditionAbbr) {
      const same = list.filter(v => v.condAbbr === item.bestConditionAbbr && v.price === item.bestConditionPrice);
      if (same.length) return same.find(v => v.printing === item.topPrinting) || same[0];
    }
    const best = d.preferBestCondition !== false;
    return list.slice().sort((a, b) => (best ? rank(a) - rank(b) || a.price - b.price : a.price - b.price || rank(a) - rank(b)))[0];
  };

  // ---------- Interface ----------
  const sel = (key, text) => `<label class="kt-ss__f"><span>${esc(text)}</span><select data-f="${key}"><option value="">${esc(key === 'groupId' ? T.allSets : T.any)}</option></select></label>`;
  root.innerHTML = `
    <input class="kt-ss__search" type="search" data-f="search" placeholder="${esc(T.search)}" aria-label="${esc(T.search)}" autocomplete="off" enterkeyhint="search">
    <details class="kt-ss__filters">
      <summary>${esc(T.filters)} <span class="kt-ss__fcount" hidden></span></summary>
      <div class="kt-ss__fgrid">
        ${sel('groupId', T.set)}${sel('rarity', T.rarity)}${sel('color', T.color)}${sel('type', T.type)}${sel('condition', T.condition)}${sel('language', T.language)}${sel('printing', T.finish)}${sel('legal', T.format)}
        <label class="kt-ss__tog"><input type="checkbox" data-f="inStock"> ${esc(T.inStockOnly)}</label>
        <button type="button" class="kt-btn kt-btn--sm" data-reset>${esc(T.reset)}</button>
      </div>
    </details>
    <div class="kt-ss__bar">
      <p class="kt-ss__count" aria-live="polite"></p>
      <label class="kt-ss__sort">${esc(T.sortBy)} <select data-f="sort">${SORTS.map(([v, k]) => `<option value="${v}">${esc(T[k])}</option>`).join('')}</select></label>
    </div>
    <div class="kt-ss__grid" role="list"></div>
    <div class="kt-ss__status" role="status"></div>
    <div class="kt-ss__more"><button type="button" class="kt-btn" data-more hidden>${esc(T.loadMore)}</button></div>`;
  // Fenêtres et messages : attachés au <body> pour passer au-dessus du thème
  // (le tiroir panier du thème s'ouvre par-dessus).
  const portal = document.createElement('div');
  portal.className = 'kt-ss kt-ss--portal';
  portal.innerHTML = `
    <div class="kt-dlg" role="dialog" aria-modal="true" aria-labelledby="kt-ss-dlg-title" hidden>
      <div class="kt-dlg__box"><button type="button" class="kt-dlg__x" data-close aria-label="${esc(T.close)}">×</button><div class="kt-dlg__in"></div></div>
    </div>
    <div class="kt-dlg kt-ndlg" role="dialog" aria-modal="true" aria-labelledby="kt-ss-n-title" hidden>
      <div class="kt-dlg__box kt-ndlg__box">
        <button type="button" class="kt-dlg__x" data-close aria-label="${esc(T.close)}">×</button>
        <h2 class="kt-ndlg__title" id="kt-ss-n-title">${esc(T.nTitle)}</h2>
        <p class="kt-ndlg__sub" data-n-sub></p>
        <p class="kt-ndlg__note" data-n-note hidden></p>
        <div data-n-login>
          <button type="button" class="kt-btn kt-btn--solid kt-btn--block" data-n-login-btn>${esc(T.nLogin)}</button>
          <p class="kt-ndlg__hint">${esc(T.nLoginHint)}</p>
          <p class="kt-ndlg__or">${esc(T.or)}</p>
        </div>
        <form class="kt-ndlg__form" data-n-form novalidate>
          <label for="kt-ss-n-email">${esc(T.nEmailLabel)}</label>
          <div class="kt-ndlg__row"><input id="kt-ss-n-email" type="email" autocomplete="email" placeholder="${esc(T.nEmailPh)}"><button type="submit" class="kt-btn">${esc(T.nSubmit)}</button></div>
        </form>
        <p class="kt-ndlg__msg" role="status" data-n-msg></p>
      </div>
    </div>
    <div class="kt-toast" role="status" aria-live="polite"></div>`;
  document.body.appendChild(portal);
  const $ = s => root.querySelector(s);
  const grid = $('.kt-ss__grid'), statusEl = $('.kt-ss__status'), countEl = $('.kt-ss__count'), moreBtn = $('[data-more]');
  const details = $('.kt-ss__filters');
  const dlg = portal.querySelector('.kt-dlg:not(.kt-ndlg)'), dlgIn = dlg.querySelector('.kt-dlg__in');
  const ndlg = portal.querySelector('.kt-ndlg');
  const nSub = ndlg.querySelector('[data-n-sub]'), nNote = ndlg.querySelector('[data-n-note]'), nLogin = ndlg.querySelector('[data-n-login]');
  const nForm = ndlg.querySelector('[data-n-form]'), nEmail = ndlg.querySelector('#kt-ss-n-email'), nMsg = ndlg.querySelector('[data-n-msg]');
  const toastEl = portal.querySelector('.kt-toast');
  const control = key => root.querySelector(`[data-f="${key}"]`);

  const setOptions = (key, values) => {
    const s = control(key);
    const first = s.options[0].outerHTML;
    s.innerHTML = first + values.map(([v, t]) => `<option value="${esc(v)}">${esc(t)}</option>`).join('');
  };
  setOptions('color', ['W', 'U', 'B', 'R', 'G', 'C', 'M'].map(c => [c, T[c]]));

  const syncControls = () => {
    Object.keys(FIELDS).forEach(k => {
      const c = control(k);
      if (!c) return;
      if (c.tagName === 'SELECT' && S[k] && ![...c.options].some(o => o.value === S[k])) c.insertAdjacentHTML('beforeend', `<option value="${esc(S[k])}">${esc(label(k, S[k]))}</option>`);
      c.value = S[k];
    });
    control('inStock').checked = S.inStock;
    const n = ['groupId', 'rarity', 'color', 'type', 'condition', 'language', 'printing', 'legal'].filter(k => S[k]).length + (S.inStock === cfg.inStock ? 0 : 1);
    const badge = $('.kt-ss__fcount');
    badge.textContent = n;
    badge.hidden = !n;
  };
  const fromURL = () => {
    const u = new URLSearchParams(location.search);
    Object.entries(FIELDS).forEach(([k, [p]]) => { if (u.has(p)) S[k] = u.get(p); });
    if (u.get('stock') === '0') S.inStock = false;
    if (u.get('stock') === '1') S.inStock = true;
  };
  const toURL = () => {
    const u = new URLSearchParams(location.search);
    Object.entries(FIELDS).forEach(([k, [p]]) => { if (S[k]) u.set(p, S[k]); else u.delete(p); });
    if (S.inStock === cfg.inStock) u.delete('stock'); else u.set('stock', S.inStock ? '1' : '0');
    const s = u.toString();
    history.replaceState(history.state, '', location.pathname + (s ? '?' + s : '') + location.hash);
  };
  const apiParams = () => {
    const p = { categoryId: cfg.category, page: S.page, limit: cfg.pageSize, inStock: S.inStock ? 'true' : '' };
    Object.entries(FIELDS).forEach(([k, [, a]]) => { if (a && S[k]) p[a] = S[k]; });
    if (S.sort) { const [sort, order] = S.sort.split(':'); p.sort = sort; p.order = order || ''; }
    return p;
  };

  const notifyBtn = (pid, fin, row) => {
    const on = isOn(String(pid), fin || '', row);
    return `<button type="button" class="kt-notify${on ? ' is-on' : ''}" data-notify data-pid="${esc(pid)}" data-fin="${esc(fin || '')}"${row ? ' data-row' : ''}${on ? ' disabled' : ''}>${esc(on ? T.wished : T.notify)}</button>`;
  };
  const refreshNotify = () => {
    document.querySelectorAll('.kt-ss [data-notify]').forEach(b => {
      const on = isOn(b.dataset.pid, b.dataset.fin || '', 'row' in b.dataset);
      b.classList.toggle('is-on', on);
      b.disabled = on;
      b.textContent = on ? T.wished : T.notify;
    });
  };

  const card = it => {
    const id = esc(it.productId);
    const name = it.name || '';
    const price = it.bestConditionPrice != null ? it.bestConditionPrice : it.fromPrice;
    const n = it.variantCount || 0;
    const printings = Array.isArray(it.printings) ? it.printings : [];
    const finish = printings.length === 1 && printings[0] !== 'Normal' ? printings[0] : '';
    const proj = projected(it);
    const foot = it.inStock && price != null
      ? `<span class="kt-card__price">${it.bestConditionAbbr ? `<small>${esc(it.bestConditionAbbr)}</small>` : ''}${esc(money(price))}</span>${n > 1 ? `<button type="button" class="kt-card__var" data-open>${esc(fill(T.variants, { n: num(n) }))}</button>` : ''}`
      : `<span class="kt-card__est" title="${esc(T.estHint)}">${proj != null ? est(proj) : esc(T.outOfStock)}</span>${notifyBtn(it.productId, '', false)}`;
    return `<article class="kt-card" role="listitem" data-id="${id}">
      <div class="kt-card__media" data-open>
        ${it.imageUrl ? `<img src="${esc(it.imageUrl)}" alt="${esc(name)}" loading="lazy" decoding="async" width="250" height="349">` : ''}
        ${it.inStock
          ? `<button type="button" class="kt-qa" data-qa aria-label="${esc(fill(T.addNamed, { name }))}" title="${esc(T.addToCart)}">${ICON}</button>`
          : `<span class="kt-badge kt-badge--out">${esc(T.outOfStock)}</span>`}
      </div>
      <p class="kt-card__set">${esc(it.groupName || '')}</p>
      <h3 class="kt-card__name"><button type="button" data-open>${esc(name)}</button></h3>
      <p class="kt-card__meta">${[it.rarity, it.number ? '#' + it.number : '', finish].filter(Boolean).map(esc).join(' · ')}</p>
      <div class="kt-card__foot">${foot}</div>
    </article>`;
  };

  let ctrl = null, loaded = 0;
  const setStatus = (msg, isErr) => {
    statusEl.classList.toggle('is-err', !!isErr);
    statusEl.innerHTML = msg ? esc(msg) + (isErr ? ` <button type="button" class="kt-btn kt-btn--sm" data-retry>${esc(T.retry)}</button>` : '') : '';
  };
  const load = async append => {
    if (ctrl) ctrl.abort();
    const mine = ctrl = new AbortController();
    if (!append) { S.page = 1; loaded = 0; }
    moreBtn.hidden = true;
    setStatus(T.loading);
    if (!append) grid.style.opacity = '.45';
    try {
      const d = await getJSON('catalog', apiParams(), mine.signal);
      if (mine !== ctrl) return;
      const items = Array.isArray(d.items) ? d.items : [];
      const total = d.total || 0;
      items.forEach(it => {
        ITEMS.set(String(it.productId), it);
        PRODUCTS.set(String(it.productId), { name: it.name, groupName: it.groupName, categoryId: it.categoryId, oracleId: it.oracleId });
      });
      const html = items.map(card).join('');
      if (append) grid.insertAdjacentHTML('beforeend', html); else grid.innerHTML = html;
      loaded += items.length;
      countEl.textContent = fill(S.inStock ? T.countStock : T.count, { n: num(total) });
      setStatus(total ? '' : T.empty);
      moreBtn.hidden = !items.length || loaded >= total;
    } catch (e) {
      if (e.name === 'AbortError') return;
      console.warn('[kt-ss] catalogue SortSwift inaccessible — vérifie data-api / le relais.', e);
      setStatus(T.error, true);
      if (append) S.page -= 1;
    } finally {
      if (mine === ctrl) grid.style.opacity = '';
    }
  };
  const changed = () => { S.page = 1; syncControls(); toURL(); load(false); };

  let toastTimer;
  const toast = (msg, isErr) => {
    toastEl.textContent = msg;
    toastEl.classList.toggle('is-err', !!isErr);
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.classList.remove('is-on'), 4000);
  };
  const noStockMsg = d => ((d.variants || []).some(v => (v.availableQty || 0) > 0) ? T.notOnline : T.soldOut);

  const quickAdd = async (id, btn) => {
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    const item = ITEMS.get(id);
    try {
      const d = await getDetail(id);
      const v = pickVariant(item, d);
      if (!v) throw new Error(noStockMsg(d));
      const opened = await addToCart(v.shopify_variant_id, 1);
      DETAIL.delete(id);
      btn.classList.add('is-done');
      setTimeout(() => btn.classList.remove('is-done'), 1600);
      if (!opened) toast(fill(T.addedNamed, { name: item ? item.name : '' }));
    } catch (e) {
      toast(e.message || T.addError, true);
    } finally {
      btn.removeAttribute('aria-busy');
    }
  };

  // ---------- Fenêtres (pile : détail, puis alerte par-dessus) ----------
  const layers = [];
  let current = null;
  const openLayer = el => {
    if (!el.hidden) return;
    el.ktLast = document.activeElement;
    el.hidden = false;
    layers.push(el);
    document.documentElement.classList.add('kt-ss-lock');
    el.querySelector('[data-close]').focus();
  };
  const closeLayer = el => {
    if (el.hidden) return;
    el.hidden = true;
    const i = layers.indexOf(el);
    if (i > -1) layers.splice(i, 1);
    if (!layers.length) document.documentElement.classList.remove('kt-ss-lock');
    if (el === dlg) current = null;
    if (el.ktLast && document.contains(el.ktLast)) el.ktLast.focus();
  };

  const vRow = v => {
    const max = Math.max(1, Math.min(v.availableQty || 1, 20));
    const ok = !!v.shopify_variant_id;
    return `<div class="kt-v" data-vid="${esc(v.shopify_variant_id || '')}">
      <span class="kt-v__cond" title="${esc(T[v.condAbbr] || v.condAbbr || '')}">${esc(v.condAbbr || '')}</span>
      <span title="${esc(LANGS[v.langAbbr] || v.langAbbr || '')}">${esc(v.langAbbr || '')}</span>
      <span>${esc(v.printing || '')}</span>
      <span class="kt-v__price">${esc(money(v.price))}</span>
      <span class="kt-v__stock">${esc(v.availableQty === 1 ? T.left1 : fill(T.leftN, { n: num(v.availableQty) }))}</span>
      <select aria-label="${esc(T.qty)}">${Array.from({ length: max }, (_, i) => `<option>${i + 1}</option>`).join('')}</select>
      <button type="button" class="kt-btn kt-btn--sm kt-btn--solid" data-add${ok ? '' : ` disabled title="${esc(T.notOnline)}"`}>${esc(T.addToCart)}</button>
    </div>`;
  };
  const renderDetail = (id, d) => {
    const p = d.product || {};
    PRODUCTS.set(String(id), { name: p.name, groupName: p.groupName, categoryId: p.categoryId, oracleId: p.oracleId });
    const vars = (d.variants || []).filter(v => (v.availableQty || 0) > 0)
      .sort((a, b) => rank(a) - rank(b) || String(a.langAbbr).localeCompare(String(b.langAbbr)) || String(a.printing).localeCompare(String(b.printing)) || a.price - b.price);
    // Impressions épuisées, avec le prix estimé par SortSwift (sans doublon ni impression déjà en stock).
    const have = new Set(vars.map(v => printLabel(v) + '|' + (v.finish === 'foil' ? 'foil' : '')));
    const seen = new Set();
    const oos = (Array.isArray(d.outOfStockPrintings) ? d.outOfStockPrintings : [])
      .filter(o => o && typeof o === 'object')
      .map(o => ({ label: printLabel(o), fin: o.finish === 'foil' ? 'foil' : '', price: projected(o) }))
      .filter(o => { const k = o.label + '|' + o.fin; if (have.has(k) || seen.has(k)) return false; seen.add(k); return true; });
    const oosRow = o => `<div class="kt-v kt-v--oos">
      <span>${esc(o.label)}</span>
      <span class="kt-v__price kt-v__price--est" title="${esc(T.estHint)}">${o.price != null ? est(o.price) : '—'}</span>
      <span class="kt-v__stock">${esc(T.outOfStock)}</span>
      ${notifyBtn(id, o.fin, true)}
    </div>`;
    dlgIn.innerHTML = `
      <div class="kt-dlg__img">${p.imageUrl ? `<img src="${esc(p.imageUrl)}" alt="${esc(p.name)}" width="300" height="419">` : ''}</div>
      <div>
        <p class="kt-card__set">${[p.groupName, p.number ? '#' + p.number : '', p.rarity].filter(Boolean).map(esc).join(' · ')}</p>
        <h2 class="kt-dlg__name" id="kt-ss-dlg-title">${esc(p.name)}</h2>
        ${p.typeLine ? `<p class="kt-dlg__type">${esc(p.typeLine)}${p.manaCost ? ' · ' + esc(p.manaCost) : ''}</p>` : ''}
        ${p.oracleText ? `<p class="kt-dlg__text">${esc(p.oracleText).replace(/\n/g, '<br>')}</p>` : ''}
        <h3 class="kt-dlg__h">${esc(T.available)}</h3>
        ${vars.length ? `<div class="kt-vlist">${vars.map(vRow).join('')}</div>` : `<p class="kt-ss__muted">${esc(T.noneInStock)}</p>${oos.length ? '' : notifyBtn(id, '', false)}`}
        ${oos.length ? `<h3 class="kt-dlg__h">${esc(T.oosTitle)}</h3><div class="kt-vlist">${oos.map(oosRow).join('')}</div>` : ''}
      </div>`;
  };
  const openDetail = async id => {
    current = id;
    dlgIn.innerHTML = `<p class="kt-ss__status">${esc(T.loading)}</p>`;
    openLayer(dlg);
    try {
      const d = await getDetail(id);
      if (current === id) renderDetail(id, d);
    } catch (e) {
      if (current === id) dlgIn.innerHTML = `<p class="kt-ss__status is-err">${esc(T.error)}</p>`;
    }
  };

  // ---------- « M'avertir » : liste de souhaits SortSwift, ou alerte par courriel ----------
  let nSubj = null;
  const subjectFor = (pid, fin) => {
    const p = PRODUCTS.get(String(pid)) || {};
    return { productId: String(pid), finish: fin || '', cardName: p.name || '', categoryId: p.categoryId != null ? p.categoryId : Number(cfg.category), oracleId: p.oracleId || null, label: [p.groupName, fin === 'foil' ? 'Foil' : ''].filter(Boolean).join(' · ') };
  };
  const setNMsg = (msg, isErr) => { nMsg.textContent = msg || ''; nMsg.className = 'kt-ndlg__msg' + (msg ? (isErr ? ' is-err' : ' is-ok') : ''); };
  const openNotify = (subj, note) => {
    nSubj = subj;
    nSub.textContent = [subj.cardName, subj.label].filter(Boolean).join(' · ');
    nNote.textContent = note || '';
    nNote.hidden = !note;
    nLogin.hidden = !(link === 'none' && loginHref());
    nForm.hidden = false;
    setNMsg('');
    if (!nEmail.value && custEmail) nEmail.value = custEmail;
    openLayer(ndlg);
  };
  const runWish = async (subj, btn) => {
    if (btn) btn.setAttribute('aria-busy', 'true');
    const r = await wishAdd(subj);
    if (btn) btn.removeAttribute('aria-busy');
    if (r.ok) { ss.set(RELOADED, null); refreshNotify(); toast(T.wishedToast); return; }
    if (r.noSession) {
      // La signature Shopify de la page a expiré : on recharge une fois et l'ajout reprend tout seul.
      if (!ss.get(RELOADED)) { ss.set(RELOADED, '1'); savePending(subj); location.reload(); return; }
      link = 'nolink';
      openNotify(subj, T.linkFail);
      return;
    }
    toast(T.wishError, true);
  };
  const onNotify = async btn => {
    if (btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
    const subj = subjectFor(btn.dataset.pid, btn.dataset.fin || '');
    if (link === 'pending') {
      btn.setAttribute('aria-busy', 'true');
      link = (await signIn()) ? 'linked' : 'nolink';
      btn.removeAttribute('aria-busy');
    }
    if (link === 'linked') runWish(subj, btn);
    else openNotify(subj, link === 'nolink' && who ? T.linkFail : '');
  };

  // ---------- Événements ----------
  grid.addEventListener('click', e => {
    const art = e.target.closest('.kt-card');
    if (!art) return;
    const nb = e.target.closest('[data-notify]');
    if (nb) { onNotify(nb); return; }
    const qa = e.target.closest('[data-qa]');
    if (qa) { quickAdd(art.dataset.id, qa); return; }
    if (e.target.closest('[data-open]')) openDetail(art.dataset.id);
  });
  root.addEventListener('change', e => {
    const f = e.target.dataset && e.target.dataset.f;
    if (!f || f === 'search') return;
    if (f === 'inStock') S.inStock = e.target.checked; else S[f] = e.target.value;
    changed();
  });
  let typing;
  control('search').addEventListener('input', e => {
    clearTimeout(typing);
    typing = setTimeout(() => { const v = e.target.value.trim(); if (v !== S.search) { S.search = v; changed(); } }, 350);
  });
  root.addEventListener('click', e => {
    if (e.target.closest('[data-reset]')) {
      Object.keys(FIELDS).forEach(k => { if (k !== 'search' && k !== 'sort') S[k] = ''; });
      S.inStock = cfg.inStock;
      changed();
    } else if (e.target.closest('[data-more]')) {
      S.page += 1;
      load(true);
    } else if (e.target.closest('[data-retry]')) {
      load(S.page > 1);
    }
  });
  dlg.addEventListener('click', async e => {
    if (e.target === dlg || e.target.closest('[data-close]')) { closeLayer(dlg); return; }
    const nb = e.target.closest('[data-notify]');
    if (nb) { onNotify(nb); return; }
    const b = e.target.closest('[data-add]');
    if (!b) return;
    const row = b.closest('.kt-v');
    const qty = parseInt(row.querySelector('select').value, 10) || 1;
    const old = row.querySelector('.kt-v__msg');
    if (old) old.remove();
    b.setAttribute('aria-busy', 'true');
    try {
      await addToCart(row.dataset.vid, qty);
      DETAIL.delete(current);
      row.insertAdjacentHTML('beforeend', `<p class="kt-v__msg is-ok">✓ ${esc(T.added)}</p>`);
    } catch (err) {
      row.insertAdjacentHTML('beforeend', `<p class="kt-v__msg is-err">${esc(err.message || T.addError)}</p>`);
    } finally {
      b.removeAttribute('aria-busy');
    }
  });
  ndlg.addEventListener('click', e => {
    if (e.target === ndlg || e.target.closest('[data-close]')) { closeLayer(ndlg); return; }
    if (e.target.closest('[data-n-login-btn]')) {
      const href = loginHref();
      if (!href || !nSubj) return;
      savePending(nSubj);
      location.href = href;
    }
  });
  nForm.addEventListener('submit', async e => {
    e.preventDefault();
    const email = nEmail.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { setNMsg(T.badEmail, true); nEmail.focus(); return; }
    const btn = nForm.querySelector('[type="submit"]');
    btn.setAttribute('aria-busy', 'true');
    const s = nSubj;
    const r = await act('restock', { email, matchScope: 'printing', productId: Number(s.productId), cardName: s.cardName || undefined, categoryId: s.categoryId != null ? Number(s.categoryId) : undefined, oracle_id: s.oracleId || undefined, finish: s.finish || null, language: null, minCondition: null });
    btn.removeAttribute('aria-busy');
    if (r.ok) {
      nForm.hidden = true;
      nLogin.hidden = true;
      setNMsg(r.data && r.data.status === 'active' ? T.subActive : T.subPending);
      ndlg.querySelector('[data-close]').focus();
    } else {
      setNMsg(r.code === 'INVALID_EMAIL' ? T.badEmail : T.subError, true);
    }
  });
  document.addEventListener('keydown', e => {
    const top = layers[layers.length - 1];
    if (!top || document.querySelector('cart-drawer.active')) return;
    if (e.key === 'Escape') { closeLayer(top); return; }
    if (e.key !== 'Tab') return;
    const f = [...top.querySelectorAll('button:not([disabled]),select,input,a[href]')].filter(el => el.offsetParent !== null);
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (!top.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
    else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  // ---------- Démarrage ----------
  fromURL();
  if (window.matchMedia('(min-width: 750px)').matches) details.open = true;
  control('search').value = S.search;
  syncControls();
  load(false);
  Promise.all([
    getJSON('groups', { categoryId: cfg.category }).catch(() => []),
    getJSON('catalog', { categoryId: cfg.category, inStock: 'true', page: 1, limit: 1 }).catch(() => null)
  ]).then(([groups, base]) => {
    if (Array.isArray(groups) && groups.length) {
      setOptions('groupId', groups.slice()
        .sort((a, b) => String(b.releaseDate || '').localeCompare(String(a.releaseDate || '')))
        .map(g => [String(g.id), g.code ? `${g.name} (${g.code})` : g.name]));
    }
    const f = base && base.facets;
    if (f) {
      Object.entries(FACETS).forEach(([key, fk]) => {
        let vals = (f[fk] || []).map(x => (typeof x === 'object' ? x.value : x)).filter(Boolean);
        if (key === 'condition') vals = vals.sort((a, b) => (a in RANK ? RANK[a] : 9) - (b in RANK ? RANK[b] : 9));
        if (vals.length) setOptions(key, vals.map(v => [v, label(key, v)]));
      });
    }
    syncControls();
  });
  // Liaison du compte : session SortSwift, cartes déjà sur la liste, ajout en attente après connexion.
  (async () => {
    if (who) link = (await signIn()) ? 'linked' : 'nolink';
    const pending = takePending();
    if (link === 'linked') {
      await loadWished();
      if (pending) runWish(pending, null);
    } else if (pending && link === 'nolink') {
      openNotify(pending, who ? T.linkFail : '');
    }
  })();
})();